import { query_checkAricDektopLicense } from "../query/aricDesktopQueries"
import { useQuery } from "@1f/react-sdk"
import sharedDatasInstance from "../sharedDatas"
import { apiErrorHelper } from "../helpers/apiErrorHelpers";

export const AricDesktopApi = () => {
    let tenantModel = sharedDatasInstance.getPropertyByName("tenantModel");
    const errorApiHelpers = apiErrorHelper();
    const checkLicense = useQuery(
        query_checkAricDektopLicense,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )

    const CheckAricDesktopLicense = async () => {
        try {
            let licenseResponse = await checkLicense.fetch({
                pIva: tenantModel.vatNumber
            });
            if(licenseResponse.data.data.checkAricDesktopLicense) {
                return licenseResponse.data.data.checkAricDesktopLicense.isDesktopEnabled;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            console.error("Error checking ARIC desktop license:", errorMessage || error);
            throw new Error(errorMessage || "Errore durante il controllo della licenza ARIC Desktop");
        }
    }

    return {
        CheckAricDesktopLicense
    }
}